export enum OperationResult {
    SUCCESS = "success",
    FAILURE = "failure",
    CANCELLED = "CANCELLED"
}
